/* eslint-disable no-console */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { encodeKebabCase } from '../../utils/formatting';
import Pagination from '../pagination/Pagination';
import Lazyload from '../../modules/lazyload';
import { setBlogPageClick } from '../../utils/browser-history-utils';

class BlogArticles extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pageOfItems: [],
      optionState: 'All',
    };

    const {
      filters,
    } = this.props;

    const options = filters.categoryFilter.options; /* eslint-disable-line prefer-destructuring */
    Object.keys(options).map((filterKey) => {
      options[filterKey].hash = encodeKebabCase(options[filterKey].name);
      return false;
    });

    this.onChangePage = this.onChangePage.bind(this);
    this.sortOnUrlHash = this.sortOnUrlHash.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  componentDidMount() {
    Lazyload();
    this.sortOnUrlHash();
  }

  componentDidUpdate() {
    Lazyload();
  }

  onChangePage(pageOfItems) {
    this.setState({ pageOfItems });
  }

  sortOnUrlHash() {
    const {
      clearFilters,
      filterClick,
      filters,
    } = this.props;

    const options = filters.categoryFilter.options; /* eslint-disable-line prefer-destructuring */
    if (window.location.hash !== '') {
      Object.keys(options).map((filterKey) => {
        if (options[filterKey].hash === window.location.hash.substr(1)) {
          this.setState({ optionState: options[filterKey].name });
          clearFilters();
          filterClick(options[filterKey]);
        }
        return false;
      });
    }
  }

  handleFilterChange(event) {
    const {
      clearFilters,
      filterClick,
      filters,
    } = this.props;

    this.setState({ optionState: event.target.value });

    const options = filters.categoryFilter.options; /* eslint-disable-line prefer-destructuring */
    let match = false;
    Object.keys(options).map((filterKey) => {
      if (options[filterKey].name === event.target.value) {
        clearFilters();
        filterClick(options[filterKey]);
        match = true;
      }
      return false;
    });
    if (!match) {
      clearFilters();
    }
  }

  render() {
    const {
      filters,
      articleItems,
    } = this.props;

    const {
      optionState,
    } = this.state;

    return (
      <div className="article-container">
        <section className="filter article-category-filter">
          <div className="container">
            <div className="row">
              <div className="col">
                <label className="filter-label body-sm" htmlFor="SortBy">
                  <strong>Filter Articles</strong>
                </label>
                <div className="article-filter-select">
                  <select onChange={this.handleFilterChange} value={optionState} id="SortBy">
                    <option key="all" value="All">All</option>
                    {filters.categoryFilter.options.map(option => (
                      <option key={option.name.toLowerCase().replace(/[\s]+/g, '-')} value={option.name}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                  <span className="select-arrow" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="article-list">
          <div className="article-wrapper container mt-5">
            {(articleItems.length > 0)
            ? (
              <div className="row all-articles">
                {this.state.pageOfItems.map(article => (
                  <div key={article.id} className="article-preview col-xs-12 col-sm-6 col-lg-4 mb-60">
                    <a className="article-preview-link d-block" href={article.articleLink} onClick={setBlogPageClick}>
                      <div className="article-primary-image-container site-image-wrapper">
                        <img className="article-primary-image lazy site-image" data-src={article.primaryImage} alt={(!article.primaryImageAltTag ? '' : article.primaryImageAltTag)} />
                      </div>
                      <div className="text-wrap mt-5">
                        <div className="article-category heading-xxs pb-3">
                          {article.articleCategories.map((category, index) => (
                            <span className="article-category-text">{category.name}{(index === article.articleCategories.length - 1 ? '' : ', ')}</span>
                          ))}
                        </div>
                        <h3 className="article-title heading-md pb-3">{article.articleTitle}</h3>
                        <p><span className="article-read-more-link">{this.props.articlesListLinkText} →</span></p>
                      </div>
                    </a>
                  </div>
                ))}
                <Pagination items={this.props.articleItems} onChangePage={this.onChangePage} />
              </div>
            ) : (
              <div className="results-message-container">
                <p>{this.props.noResultsMessage}</p>
              </div>
            )}
          </div>
        </section>
      </div>
    );
  }
}

BlogArticles.propTypes = {
  articleItems: PropTypes.string,
  noResultsMessage: PropTypes.string,
  articlesListLinkText: PropTypes.string,
  filterClick: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  filters: PropTypes.shape(PropTypes.object), /* eslint-disable-line react/forbid-prop-types */
};

export default BlogArticles;
/* eslint-enable no-console */
